module.exports = __webpack_public_path__ + "img/carbonneBigCenter.d29ec73c.png";